export default "__VITE_ASSET__95d0fc29__"